import { pWarn } from '_/helpers/logger';

import { eventBus } from '_/helpers/eventBus';

const photonConfig = require('~/config/config.json');

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        vuexModule: {
            required: true,
            type: String,
        },
        defaultValue: {
            type: [Boolean, String],
        },
        disabled: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        type: {
            default: 'text',
            type: String,
        },
        value: {
            default: null,
            type: [Number, String],
        },
        focus: {
            default: false,
            type: Boolean,
        },
        refreshFields: {
            type: Number,
        },
    },

    /**
     * Set the component data
     *
     * @return  {object}
     */
    data() {
        return {
            marker: null,
        };
    },

    /**
     * Set the computed properties
     *
     * @type  {object}
     */
    computed: {
        /**
         * Define the admin getter
         *
         * @return  {object}
         */
        admin() {
            const getterName = `${this.vuexModule}/${this.vuexModule}`;

            return this.$store.getters[getterName];
        },

        /**
         * Sets the map center
         *
         * @return  {object}
         */
        center() {
            if (this.marker) {
                return this.marker;
            }

            return photonConfig.locationStartCoordinates;
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Creates the event payload
         *
         * @param   {object}  event
         * @return  {object}
         */
        createEventPayload(event) {
            return {
                event,
                id: event.target.id,
                name: event.target.name,
                value: event.target.value,
            };
        },

        /**
         * Emmits a change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onChange: function (event) {
            this.$emit('change', this.createEventPayload(event));

            eventBus.$emit('fieldTypeChange', this.createEventPayload(event));
        },

        /**
         * Emmits a global change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onBlur: function (event) {
            eventBus.$emit('fieldTypeBlur', this.createEventPayload(event));
        },

        /**
         * Sets a component value to defaultValue, if required
         *
         * @return  {void}
         */
        setDefaultValueIfRequired() {
            if (this.defaultValue && this.admin.editorMode === 'create') {
                this.$emit('change', {
                    id: this.id,
                    name: this.name,
                    value: this.defaultValue,
                });
            }
        },

        /**
         * Sets a marker
         *
         * @param  {object}  place
         * @return {void}
         */
        setMarker(place) {
            if (this.disabled) {
                return;
            }

            this.marker = {
                lat: place.latLng.lat(),
                lng: place.latLng.lng(),
            };
        },

        /**
         * Sets a marker from state
         *
         * @return {void}
         */
        setMarkerLatLng() {
            const regexPattern = /^([-+]?)([\d]{1,2})(((\.)(\d+)(,)))(\s*)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/;

            if (regexPattern.test(this.value)) {
                let cords = this.value.split(', ');

                this.marker = {
                    lat: parseFloat(cords[0]),
                    lng: parseFloat(cords[1]),
                };
            } else {
                this.marker = null;
            }
        },

        /**
         * Updates the input value
         *
         * @return {void}
         */
        updateInputValue() {
            this.value = this.marker.lat.toString() + ', ' + this.marker.lng.toString();

            this.$emit('change', this);
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.setDefaultValueIfRequired();

            this.setMarkerLatLng();
            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `InputTag.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.setDefaultValueIfRequired();

                this.$forceUpdate();

                $(this.$el).val(this.value);

                if (this.focus) {
                    $(this.$el).find(`#${this.id}`).focus();
                }
            }
        },

        marker: function (newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                this.updateInputValue();
            }
        },

        $route(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                this.setMarkerLatLng();
            }
        },

        value: function () {
            this.setMarkerLatLng();
        },
    },
};
